// extracted by mini-css-extract-plugin
module.exports = {"subscriptionLabel":"SubscribeAndSaveLabel_subscriptionLabel__1DnKT"};